import { dev } from '$app/environment';
import { env } from '$env/dynamic/public';

export const DEFAULT_FRONTEND_DEV_VERSION = '0.0.0-dev';

export function resolveFrontendVersion(isDev: boolean, publicVersion: string | undefined): string {
	if (isDev) {
		return DEFAULT_FRONTEND_DEV_VERSION;
	}
	return publicVersion?.trim() || DEFAULT_FRONTEND_DEV_VERSION;
}

export const frontendVersion = resolveFrontendVersion(dev, env.PUBLIC_DS_FRONTEND_VERSION);

export const versionRequestHeaderValue = `ver=${frontendVersion}`;
